import { useState } from 'react';

import { CarCheckerHero } from './CarCheckerHero/CarCheckerHero';
import { CarCheckFAQ } from './CarCheckFAQ/CarCheckFAQ';
import { CarCheckReport } from './CarCheckReport';
import type { TccCarCheckResponse } from './CarCheckReport.types';

export const CarCheck = () => {
  const [tccData, setTccData] = useState<TccCarCheckResponse | null>(null);

  return (
    <>
      <CarCheckerHero { ...{ setTccData } } />
      {tccData && <CarCheckReport response={tccData} />}
      {!tccData && (<CarCheckFAQ />)}
    </>
  );
};
